<h1 mat-dialog-title> Nueva Tarjeta de Publicidad </h1>

<div mat-dialog-content>
  <form [formGroup]='options'>
    <div class="izq">
      <div class="asunto" style="margin-top: 5%">
        <mat-form-field>
          <input matInput aria-label="Titulo" placeholder="Titulo" formControlName='tituloCtrl' [(ngModel)]="publicidad.titulo" required
            maxlength="50" oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)">
        </mat-form-field>
        <mat-error
          *ngIf=' options.controls.tituloCtrl.invalid && (options.controls.tituloCtrl.dirty || options.controls.tituloCtrl.touched) && options.controls.tituloCtrl.errors.required'>
          El campo es requerido.</mat-error>
      </div>
    </div>
      <div class="asunto" style="margin-top: 5%">
        <mat-form-field>
          <input matInput aria-label="URL Vinculo" placeholder="URL Vinculo" formControlName='urlCtrl' [(ngModel)]="publicidad.url" required
            maxlength="250"  oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)">
        </mat-form-field>
        <mat-error
          *ngIf=' options.controls.urlCtrl.invalid && (options.controls.urlCtrl.dirty || options.controls.urlCtrl.touched) && options.controls.urlCtrl.errors.required'>
          El campo es requerido.</mat-error>
      </div>
      <div class="asunto" style="margin-top: 5%">
        <mat-form-field>
          <textarea matInput aria-label="Descripción" placeholder="Descripción" formControlName='descripcionCtrl'
            [(ngModel)]="publicidad.descripcion" maxlength="512"
            oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
        </mat-form-field>
      </div>
      <div class="asunto" style="margin-top: 5%" *ngIf="showImagen">
          <img width="140px" height="170px" class="img" src="{{publicidad.imagenConvert}}">
      </div>

    
      <div class="col-md-12 col-sm-12">
        <div class="row">
          <div class="col-md-5 col-sm-12">
            <div class="fileinput fileinput-new text-center" data-provides="fileinput" style="padding-top: 0%">
              <div>
                <p class="text-muted">Imagen: {{nombreImagen}}
                  <button class="btn btn-info btn-sm btn-file" *ngIf="showBtnAddImagen">
                    &nbsp; Agregar
                    <input aria-label="Agregar" type="file" id="nameFile"
                      accept="image/*" mozdirectory
                      directory multiple (change)='subirEv()'/>
                  </button>
                  <button  mat-raised-button class="btn btn-info btn-sm" type="submit"
                  (click)="elimina()" *ngIf="!showBtnAddImagen">
                  &nbsp; Eliminar
                </button>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="asunto" *ngFor="let item of evidencia; index as i" style="margin-top: 5%">
            <mat-form-field>
              <input matInput formControlName='imagenCtrl' [(ngModel)]="publicidad.imagen" value="{{item.name}}" required readonly
              oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)" >
            </mat-form-field>
            <mat-error
              *ngIf=' options.controls.imagenCtrl.invalid && (options.controls.imagenCtrl.dirty || options.controls.imagenCtrl.touched) && options.controls.imagenCtrl.errors.required'>
              La imagen es requerida.</mat-error>
          </div> -->
        </div>
      </div>
  </form>
</div>



<div mat-dialog-actions class="justify-content-end">
  <button mat-button class="btn btn-default" (click)="limpiar()">
    <i class="fa fa fa-trash-o"></i> Limpiar
  </button>
  <button mat-button class="btn btn-danger" (click)='salir()'>
    <i class="fa fa-times-circle-o"></i> Cancelar
  </button>

  <button mat-button (click)='guardar()' class="btn  btn-success" [disabled]="(!showBtnGuardar || !options.valid)"
  onClick="this.disabled=true">
  Guardar <i class='material-icons'> save </i>
</button>
</div>